import React, { useState, useEffect } from 'react'
import Login from "./components/login"
import Register from "./components/register"
import Userpage from "./components/userpage"
import About from "./components/about"
import { BrowserRouter, Router, Route, Switch } from 'react-router-dom'

function App() {
  const [token, setToken] = useState()

  const $sslTag = document.createElement("meta")
  useEffect(() => {
    $sslTag.httpEquiv = "Content-Security-Policy"
    $sslTag.content = "upgrade-insecure-requests"
    document.head.append($sslTag)
  })

  if (!token) return <BrowserRouter>
    <div>
      <Switch>
        <Route path='/about'>
          <About loggedIn={false} />
        </Route>
        <Route path='/register'>
          <Register />
        </Route>
        <Route path='/'>
          <Login setToken={setToken} />
        </Route>
      </Switch>
    </div>

  </BrowserRouter>



  else return <BrowserRouter>
    <div>
      <Switch>
        <Route path='/about'>
          <About setToken={setToken} loggedIn={true} />
        </Route>
        <Route path='/'>
          <Userpage username={token} setToken={setToken} />
        </Route>
      </Switch>
    </div>
  </BrowserRouter>
}

export default App;
